import React, { useMemo, useState } from "react";
import Heading from "./Heading";
import { CgChevronDoubleRight, CgChevronDoubleLeft } from "react-icons/cg";
import Project from "./Project";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useFetch from "../hooks/useFetch";
import ProjectSkeleton from "../skeletons/ProjectSkeleton";
import VideoModal from "./VideoModal";
import { useInView } from "react-intersection-observer";
import { AnimatePresence } from "framer-motion";

function Projects() {
  const [videoModal, setVideoModal] = useState({ isOpen: false, url: "" });
  const [currentProject, setCurrentProject] = useState(1);
  const { ref, inView } = useInView({ threshold: 0.2 });

  const { data: projects, isLoading } = useFetch(
    `https://manak-dev-api.herokuapp.com/api/projects?populate=*&sort=publishedAt:desc`
  );
  const responsive = {
    lg: {
      breakpoint: { max: Infinity, min: 769 },
      items: 2,
    },
    md: {
      breakpoint: { max: 768, min: 601 },
      items: 1,
    },
    sm: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  };
  return (
    <section
      ref={ref}
      className="bg-prColor overflow-clip section"
      id="portfolio"
    >
      <div className="container pt-[40px] sm:pt-[60px] md:pt-[90px] pb-6 sm:pb-12">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div>
            <Heading
              title={"My Recent Projects"}
              subTitle="Awesome Portfolio"
            />
          </div>
          <div className="text-light font-[Poppins] text-sm sm:text-base md:text-lg lg:text-xl self-end pb-4">
            {currentProject} <span className="text-dark">out of </span>{" "}
            {!isLoading && projects.length}
          </div>
        </div>
      </div>
      <Carousel
        responsive={responsive}
        infinite={false}
        keyBoardControl={false}
        customTransition={
          window.innerWidth > 600
            ? "transform 1500ms ease-in-out"
            : "transform 500ms ease-in-out"
        }
        transitionDuration={window.innerWidth > 600 ? 1500 : 500}
        autoPlaySpeed={8000}
        customRightArrow={
          <CustomRightArrow
            getSlide={(slide) =>
              setCurrentProject(() => slide + (window.innerWidth < 768 ? 1 : 2))
            }
          />
        }
        customLeftArrow={
          <CustomLeftArrow
            getSlide={(slide) =>
              setCurrentProject(() => slide + (window.innerWidth < 768 ? 1 : 2))
            }
          />
        }
        itemClass="px-3 md:px-4 xl:px-8"
        centerMode={false}
      >
        {isLoading
          ? [1, 2].map((n) => <ProjectSkeleton key={n} />)
          : projects.map((project, index) => (
              <Project
                title={project.attributes.shortTitle}
                imageUrl={`${project.attributes.imgs.data[0].attributes.url}`}
                liveUrl={project.attributes.liveUrl}
                videoUrl={project.attributes.videoUrl || ""}
                setVideoModal={setVideoModal}
                githubUrl={project.attributes.githubUrl || "/"}
                scale={project.attributes.scale}
                techStack={project.attributes.skills.data}
                slug={project.attributes.slug}
                key={index}
                inView={inView}
              />
            ))}
      </Carousel>
      <AnimatePresence exitBeforeEnter>
        {videoModal.isOpen && (
          <VideoModal url={videoModal.url} setVideoModal={setVideoModal} />
        )}
      </AnimatePresence>
    </section>
  );
}
const CustomRightArrow = ({ onClick, getSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  useMemo(() => getSlide(currentSlide), [getSlide, currentSlide]);
  return (
    <button
      type="button"
      className="btn-secondary top-[32%] translate-in translate-x-60"
      style={{ right: "calc(4% - 1px)" }}
      onClick={() => onClick()}
    >
      <CgChevronDoubleRight fontSize={22} />
    </button>
  );
};
const CustomLeftArrow = ({ onClick, getSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  useMemo(() => getSlide(currentSlide), [getSlide, currentSlide]);
  return (
    <button
      type="button"
      className="btn-secondary top-[32%] translate-in -translate-x-60"
      style={{ left: "calc(4% - 1px)" }}
      onClick={() => onClick()}
    >
      <CgChevronDoubleLeft fontSize={22} />
    </button>
  );
};
export default Projects;
